import React from 'react';
import styled from 'styled-components';
import { Alert as BsAlert } from 'react-bootstrap';
import { MdInfo, MdCheckCircle, MdWarning, MdError } from 'react-icons/md';
import { colors, radius, spacing, typography } from '../tokens';

// Alert — wrap react-bootstrap Alert. Map variant tokens → soft
// background + dark text + icon mặc định cho mỗi variant. Thay
// `variant` mặc định của Bootstrap (xanh nhạt, vàng nhạt...) bằng
// palette nhất quán hơn.

const VARIANT_STYLE = {
  info: { bg: colors.infoSoft, fg: '#0c4a6e', border: '#bae6fd', Icon: MdInfo },
  success: { bg: colors.successSoft, fg: '#14532d', border: '#bbf7d0', Icon: MdCheckCircle },
  warning: { bg: colors.warningSoft, fg: '#78350f', border: '#fde68a', Icon: MdWarning },
  danger: { bg: colors.dangerSoft, fg: '#7f1d1d', border: '#fecaca', Icon: MdError },
};

function Alert({ variant = 'info', title, children, icon, dismissible, onClose, className }) {
  const style = VARIANT_STYLE[variant] || VARIANT_STYLE.info;
  const Icon = icon === false ? null : (icon || style.Icon);

  return (
    <StyledAlert
      $bg={style.bg}
      $fg={style.fg}
      $border={style.border}
      dismissible={dismissible}
      onClose={onClose}
      className={className}
    >
      <Row>
        {Icon && (
          <IconWrap>
            <Icon size={20} />
          </IconWrap>
        )}
        <Content>
          {title && <Title>{title}</Title>}
          <Body>{children}</Body>
        </Content>
      </Row>
    </StyledAlert>
  );
}

const StyledAlert = styled(BsAlert)`
  background: ${(p) => p.$bg};
  color: ${(p) => p.$fg};
  border: 1px solid ${(p) => p.$border};
  border-radius: ${radius.md};
  padding: ${spacing[3]} ${spacing[4]};
  font-size: ${typography.size.sm};
  line-height: ${typography.leading.relaxed};
  margin-bottom: ${spacing[4]};
`;

const Row = styled.div`
  display: flex;
  gap: ${spacing[3]};
  align-items: flex-start;
`;

const IconWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  padding-top: 2px;
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.div`
  font-weight: ${typography.weight.semibold};
  margin-bottom: ${spacing[1]};
`;

const Body = styled.div`
  font-size: ${typography.size.sm};
`;

export default Alert;
